
































































































import Vue, { VueConstructor } from 'vue'
import { eventHub } from '@/store/eventHub'
import { mapState } from 'vuex'
import MainLink from '@/assets/main.svg'
import { vue_app_version } from '@/helpers/constants'

export default Vue.extend({
  name: 'SecondaryNav',
  props: ['towns'],
  components: { MainLink: MainLink as VueConstructor<Vue> },
  computed: {
    ...mapState('auth', ['user']),
    townsMenuLabel(): string {
      // TODO - can get unique name easier via vuex like this, kinda: this.$store.getters['towns/townByName'](town.name));
      let names : {[key: string] : string} = {}
      this.towns.forEach((town: { uniqueName: string; name: string }) => { names[town.uniqueName] = town.name } )
      return (this.$route.params.townName && Object.keys(names).includes(this.$route.params.townName))
        ? `${this.$t('Moderating')}: ${names[this.$route.params.townName]}`
        : this.$t('Overview')
    },
    moderatedTowns(): number[] {
      return this.user.accesses
        .filter((access: { privilege: { id: number } }) => [3, 4].includes(access.privilege.id))
        .map((access: { to: number }) => access.to)
        .filter((value: number, index: number, self: number[]) => self.indexOf(value) === index)
    }
  },

  created() {
    if(Object.keys(this.towns).length) this.filterTowns()
  },

  data() {
    return {
      townLinks: [
        {
          path: 'posts',
          text: 'Posts',
          children: [
            {
              pathEnding: 'posts',
              title: 'Approve Posts'
            },
            {
              pathEnding: 'search',
              title: 'Search Posts'
            }
          ]
        },
        {
          path: 'members',
          text: 'Members',
          children: [
            {
              pathEnding: 'members',
              title: 'Approve Members'
            },
            {
              pathEnding: 'search',
              title: 'Search Members'
            },
            {
              pathEnding: 'invite',
              title: 'Invite Members'
            }
          ]
        },
        {
          path: 'settings',
          text: 'Town Settings',
          children: [
            {
              pathEnding: 'settings',
              title: 'General'
            },
            {
              pathEnding: 'activity',
              title: 'Town Activity'
            },
            {
              pathEnding: 'notices',
              title: 'Town Notices'
            },
            {
              pathEnding: 'hotwords',
              title: 'Hotwords'
            }
          ]
        }
      ],
      townsFiltered: [],
      townsSearchString: '',
      version: vue_app_version
    }
  },

  methods: {
      filterTowns(needle?: string) {
          const townsFiltered = {}
          if(!needle || needle === '') {
              for(let town of Object.keys(this.towns)) {
                  if(town !== this.$route.params.townName) Object.assign(townsFiltered, {[town]: this.towns[town]})
              }
          } else {
              for(let town of Object.keys(this.towns)) {
                  if(town.toLowerCase().includes(needle.toLowerCase()) && town !== this.$route.params.townName) Object.assign(townsFiltered, {[town]: this.towns[town]})
              }
          }
          Vue.set(this, 'townsFiltered', Object.values(townsFiltered))
      },
      refreshTowns() {
          eventHub.$emit('triggerSnackbar', {
              color: 'success', text: this.$t('Refreshing the list of towns you moderate.')
          })
          this.$store.dispatch('towns/fetchTowns')
      },
      updateFilteredTowns() {
          this.filterTowns(this.townsSearchString)
      }
  },

  watch: {
      townsSearchString(v) {
          this.filterTowns(v)
      },
      towns() {
          this.updateFilteredTowns()
      }
  }
})
